import { ReactElement } from 'react';
import { Link } from '@mui/material';
import { AgwRestApiIntegrationResponse } from '@localstack/types';
import { getSchema } from '@localstack/services';

import { MagicTable } from '../../../magic/MagicTable';

export type AgwRestApiIntegrationResponsesTableProps = {
  selectable?: boolean;
  loading?: boolean;
  responses: AgwRestApiIntegrationResponse[];
  onViewResponse?: (response: AgwRestApiIntegrationResponse) => unknown;
  onSelect?: (ids: string[]) => unknown;
};

export const AgwRestApiIntegrationResponsesTable = ({
  responses,
  selectable = true,
  loading,
  onViewResponse,
  onSelect,
}: AgwRestApiIntegrationResponsesTableProps): ReactElement => (
  <MagicTable
    schema={getSchema('APIGateway')}
    entry="IntegrationResponse"
    idAttribute="statusCode"
    rows={responses}
    selectable={selectable}
    onSelect={onSelect}
    order={['statusCode']}
    loading={loading}
    externalFields={{
      statusCode: (row) => (
        <Link onClick={() => onViewResponse && onViewResponse(row)} underline="hover">
          {row.statusCode}
        </Link>
      ),
    }}
  />
);
